/**
 * Everything under the Tickets nav (Board/List/Backlog/Plans) is scoped to a
 * Project, selected via the sidebar dropdown. The project id lives in the
 * URL (source of truth while browsing) and is mirrored to localStorage so
 * landing on the bare /tickets route or opening the sidebar on a non-ticket
 * page can restore the last project the user was working in.
 */
export const LAST_PROJECT_KEY = "ats_last_project_id";

export const VIEWS = ["board", "list", "backlog", "plans"];

export function projectViewPath(projectId, view = "board") {
  const safeView = VIEWS.includes(view) ? view : "board";
  return `/tickets/p/${projectId}/${safeView}`;
}

export function rememberProject(projectId) {
  try {
    localStorage.setItem(LAST_PROJECT_KEY, String(projectId));
  } catch {
    // localStorage can throw in private-browsing/storage-restricted contexts -- non-fatal
  }
}

export function getRememberedProjectId() {
  try {
    return localStorage.getItem(LAST_PROJECT_KEY);
  } catch {
    return null;
  }
}

/** Picks the remembered project if it still exists, else the first project in the list. */
export function resolveDefaultProject(projects) {
  if (!projects || projects.length === 0) return null;
  const lastId = getRememberedProjectId();
  return projects.find((p) => String(p.id) === lastId) || projects[0];
}
